import * as yup from "yup";
import { alphabet_regix, numeric_decimal_regix } from "../utils/functions";

export const client_classification_schema = (data) => ({
    corpClientApplicationClientClassificationId: data?.corpClientApplicationClientClassificationId ?? null,
    clientClassificationId: data?.clientClassification ?? null,
    ifInstitutionalInvestorSelectOneOfTheFollowingCriteria: data?.ifInstitutionalInvestorSelectOneOfTheFollowingCriteria ?? null,
    ifQualifiedInvestorSelectOneOfTheFollowingCriteria: data?.ifQualifiedInvestorSelectOneOfTheFollowingCriteria ?? null,
    whatIsTheSourceOfFundsForThisAccount: data?.whatIsTheSourceOfFundsForThisAccount ?? "",
    doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities: data?.doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities ?? null,
    howYouEvaluateYourInvestmentKnowledgeAndExperience: data?.howYouEvaluateYourInvestmentKnowledgeAndExperience ?? null,
    howOftenHaveTheInstituionInvestedInFinancialSecurities: data?.howOftenHaveTheInstituionInvestedInFinancialSecurities ?? null,
    estimateTotaVolumeOfThoseTransactionsInSAR: data?.estimateTotaVolumeOfThoseTransactionsInSAR ?? "",
    howHasTheInstitutionMadeTheseInvestments: data?.howHasTheInstitutionMadeTheseInvestments ?? null,
    forHowManyYearsHasTheInstitutionInvestedInFinancialSecurities: data?.forHowManyYearsHasTheInstitutionInvestedInFinancialSecurities ?? null,
    hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears: data?.hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears ?? null,
    estimateTotalVolumeOfYourInstitutionMarginInThePastFiveYears: data?.estimateTotalVolumeOfYourInstitutionMarginInThePastFiveYears ?? "",
    classificationFundCurrentLocations: data?.classificationFundCurrentLocationViewResponses ?? [],
    clientClassificationTypeOfInvestments: data?.clientClassificationTypeOfInvestments ?? [],
    edaaClassification: data?.edaaClassification ?? null,
    jadwaClassification: data?.jadwaClassification ?? null,
    netWorthClassification: data?.netWorthClassification ?? null,
});

export const client_classification_validation_schema = yup.object().shape({
    clientClassificationId: yup
        .number()
        .nullable(),
        // .required("atleast_1_option_should_be_selected"),
    ifInstitutionalInvestorSelectOneOfTheFollowingCriteria: yup
        .number()
        .nullable(),
        // .when("clientClassificationId", {
        //     is: 1069,
        //     then: (schema) => schema.required("atleast_1_option_should_be_selected"),
        //     otherwise: (schema) => schema.nullable(),
        // }),
    ifQualifiedInvestorSelectOneOfTheFollowingCriteria: yup
        .number()
        .nullable(),
        // .when("clientClassificationId", {
        //     is: 1070,
        //     then: (schema) => schema.required("atleast_1_option_should_be_selected"),
        //     otherwise: (schema) => schema.nullable(),
        // }),
    whatIsTheSourceOfFundsForThisAccount: yup
        .string()
        // .required("source_of_fund_required")
        .matches(alphabet_regix, "characters_should_be_alphabets")
        .nullable(),
    classificationFundCurrentLocations: yup
        .array()
        .nullable(),
        // .of(
        //     yup.object().shape({
        //         valueId: yup.number().required("atleast_1_option_should_be_selected"),
        //     }),
        // )
        // .min(1, "atleast_1_option_should_be_selected"),
    doesInstitutionFieldWorkRelateToInvestingInFinancialSecurities: yup
        .boolean()
        .nullable(),
        // .required("field_work_relate_to_investing_required"),
    howYouEvaluateYourInvestmentKnowledgeAndExperience: yup
        .number()
        .nullable(),
        // .required("atleast_1_option_should_be_selected"),
    howOftenHaveTheInstituionInvestedInFinancialSecurities: yup
        .number()
        .nullable(),
        // .required("atleast_1_option_should_be_selected"),
    estimateTotaVolumeOfThoseTransactionsInSAR: yup
        .string()
        // .required("total_volume_of_transactions_required")
        .matches(numeric_decimal_regix, "input_should_be_numeric")
        .nullable(),
    howHasTheInstitutionMadeTheseInvestments: yup
        .number()
        .nullable(),
        // .required("atleast_1_option_should_be_selected"),
    forHowManyYearsHasTheInstitutionInvestedInFinancialSecurities: yup
        .number()
        .nullable(),
    clientClassificationTypeOfInvestments: yup
        .array()
        .nullable(),
        // .of(
        //     yup.object().shape({
        //         valueId: yup.string().required("atleast_1_option_should_be_selected"),
        //     }),
        // )
        // .min(1, "atleast_1_option_should_be_selected"),
    hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears: yup
        .boolean()
        .nullable(),
    estimateTotalVolumeOfYourInstitutionMarginInThePastFiveYears: yup
        .string()
        .matches(numeric_decimal_regix, "input_should_be_numeric")
        .nullable(),
        // .when("hasTheInstitutionConductedAnyMarginTransactionsInThePastFiveYears", {
        //     is: true,
            // then: (schema) => schema.required("total_volume_of_transactions_required"),
        //     otherwise: (schema) => schema,
        // }),
});
